export const globalConfig = {
  baseURL: "https://prod.spsdoda.co.kr",
  // baseURL: "https://dev.spsdoda.co.kr",
  // baseURL: "http://localhost:5001",
};
